/* eslint-disable eqeqeq */
import React, { useContext, useRef, useState, useEffect } from "react";
import "./Navbarv2.scss";
import { Link, useHistory, BrowserRouter } from "react-router-dom";
import StateContext from "../../StateContext";
import DispatchContext from "../../DispatchContext";
import Button from "@material-ui/core/Button";
import ButtonGroup from "@material-ui/core/ButtonGroup";
import Badge from "@material-ui/core/Badge";
import CloseIcon from '@mui/icons-material/Close';
import ClickAwayListener from "@material-ui/core/ClickAwayListener";
import notificationIcon from "../../Assets/images/notificationIcon.svg"
import Grow from "@material-ui/core/Grow";
import Paper from "@material-ui/core/Paper";
import Popper from "@material-ui/core/Popper";
import MenuItem from "@material-ui/core/MenuItem";
import MenuList from "@material-ui/core/MenuList";
import IconButton from "@material-ui/core/IconButton";
import MenuIcon from "@material-ui/icons/Menu";
import SwipeableDrawer from "@material-ui/core/SwipeableDrawer";
import useMediaQuery from "@material-ui/core/useMediaQuery";
import Axios from "axios";
import { makeStyles } from "@material-ui/core/styles";
import AccountBalanceWalletIcon from "@material-ui/icons/AccountBalanceWallet";
import Snackbar from "@material-ui/core/Snackbar";
import MuiAlert from "@material-ui/lab/Alert";
import Menu from "@mui/material/Menu";
import checkboxCircle from "../../Assets/images/checkboxCircle.svg"
import List from "@material-ui/core/List";
import ListItem from "@material-ui/core/ListItem";
import ListItemText from "@material-ui/core/ListItemText";
import ListItemAvatar from "@material-ui/core/ListItemAvatar";
import Avatar from "@material-ui/core/Avatar";
import ReceiptIcon from "@material-ui/icons/Receipt";
import { withTranslation, useTranslation, Trans } from "react-i18next";
import maleLogo from "../../Assets/images/male-avatar.png";
import profile from "../../Assets/images/profile.svg"
import transaction from "../../Assets/images/transaction.svg"
import logout from "../../Assets/images/logout.svg"
import promocode from "../../Assets/images/promocode.svg"
import orders from "../../Assets/images/order.svg"
import rewards from "../../Assets/images/rewards.svg"
import Newspaper from "../../Assets/images/Newspaper.svg"
import Wallet from "../../Assets/images/Wallet.svg"
import { handleError } from "../../Functions/getAlert";
import vendorsConfig from "../../vendorsConfig";

const useStyles = makeStyles((theme) => ({
  root: {
    display: "flex",
    justifyContent: "center",
    height: "100vh",
    alignItems: "center",
  },
}));

function Alert(props) {
  return <MuiAlert elevation={6} variant="filled" {...props} />;
}
function Navbarv2(props) {

  const { t } = useTranslation();
  const [alertMessage, setAlertMessage] = useState({
    open: false,
    message: "",
  });
  const classes = useStyles();
  const [isLoading, setIsLoading] = useState(true);
  const minDesktop = useMediaQuery("(min-width: 992px)");
  const appDispatch = useContext(DispatchContext);
  const appState = useContext(StateContext);
  // const [appState.profile., setappState.profile] = useState(appState.profile);
  let history = useHistory();
  const [open, setOpen] = useState(false);
  const anchorRef = useRef(null);
  const [menuAnchor, setMenuAnchor] = useState({ open: false });
  const [openModal, setOpenModal] = useState(false);
  const [notifyCount, setNotifyCount] = useState(0);
  const [notifications, setNotifications] = useState([]);
  const [counter, setCounter] = useState(0);
  const [count, setCount] = useState(1);
  const [auth, setAuth] = React.useState(true);
  const [anchorEl, setAnchorEl] = React.useState(null);
  const handleToggle = () => {
    setOpen((prevOpen) => !prevOpen);
  };
  const handleMenu = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleChange = (event) => {
    setAuth(event.target.checked);
  };
  const handleCloseNoti = () => {
    setAnchorEl(null);
  };

  const handleLogout = () => {
    appDispatch({ type: "logout" });
    history.push('/');
  };
  const toggleDrawer = (open) => (event) => {
    if (
      event &&
      event.type === "keydown" &&
      (event.key === "Tab" || event.key === "Shift")
    ) {
      return;
    }

    setMenuAnchor({ open });
  };
  const handleClose = (event) => {
    if (anchorRef.current && anchorRef.current.contains(event.target)) {
      return;
    }

    setOpen(false);
  };
  const AllTabs = document.querySelectorAll(".tabs");
  const handleClick = () => {
    setMenuAnchor({ open: false });
  };

  const handleTabToggle = () => {
    let tabIndex = 0;
    if (window.location.pathname === `/dashboard/transactions`) {
      tabIndex = 0;
    } else if (
      window.location.pathname === `/dashboard/orders`
    ) {
      tabIndex = 1;
    } else if (
      window.location.pathname === `/dashboard/promo`
    ) {
      tabIndex = 2;
    } else if (
      window.location.pathname === `/dashboard/rewards`
    ) {
      tabIndex = 3;
    } else if (
      window.location.pathname === `/dashboard/profile`
    ) {
      tabIndex = 4;
    }
    if (props.handleChange) {
      props.handleChange(AllTabs, tabIndex);
    }
  };

  useEffect(() => {
    handleTabToggle();
  }, [window.location.pathname]);

  const handleModalOpen = (e) => {
    e.preventDefault();
    setOpenModal(true);
  };
  const walletShow = () => {

    if (appState.profile) {
      history.push("/wallet");
    } else if (appState.profile.wallet == null) {
      if (appState.profile.meta.iban != "" || appState.profile.meta.iban != null) {
        setAlertMessage({
          open: true,
          message: "KYC is underProcess",
          alertSuccess: false,
        });
      } else {
        setAlertMessage({
          open: true,
          message: "Please do KYC first.",
          alertSuccess: false,
        });
      }
    }
  };
  const arLanguageHandle = (e) => {
    appDispatch({
      type: "LangChange",
      langValue: "ar",
    });
    //   i18n.changeLanguage('ar')
  };
  const enLanguageHandle = (e) => {
    appDispatch({
      type: "LangChange",
      langValue: "en",
    });
  };
  useEffect(() => {
    setTimeout(
      () => setAlertMessage({ open: false, message: "", alertSuccess: false }),
      5000
    );
  }, [alertMessage.open]);
  const isToday = (someDate) => {
    const today = new Date()
    return someDate.getDate() == today.getDate() &&
      someDate.getMonth() == today.getMonth() &&
      someDate.getFullYear() == today.getFullYear()
  }
  const isYesterday = (someDate) => {
    const today = new Date((new Date()).valueOf() - 1000 * 60 * 60 * 24);
    return someDate.getDate() == today.getDate() &&
      someDate.getMonth() == today.getMonth() &&
      someDate.getFullYear() == today.getFullYear()
  }
  useEffect(() => {
    const fetchNotification = async () => {
      setIsLoading(true);
      try {
        const response = await Axios.get(
          `${process.env.REACT_APP_API_URL}notification`,
          {
            headers: {
              Authorization: `Bearer ${appState.token}`,
            },
          }
        );
        var notiCount = 0;
        if (response.data.success == true) {
          // console.log(response)
          response.data.data.map((val) => {
            if (!val.readed) {
              notiCount++;
            }
            // val.readed == true ? notiCount = notiCount + 1 : notiCount = notiCount ;
          });
          setNotifyCount(notiCount);
          let res = response.data.data;
          if (res.length > 0) {

            res.forEach(val => {
              let orderTime = new Date(val.created_at)
              let month = val.created_at.split(',')
              let date = month[1].split(' ')
              let orderDate = `${date[2]}${date[1]}`
              let data = {
                created_at: val.created_at,
                data: val.data,
                id: val.id,
                readed: val.readed,
                showTime: isToday(orderTime) ? 'Today' : isYesterday(orderTime) ? "Yesterday" : orderDate
              }
              notifications.push(data)
            });
            setNotifications(notifications);
          }
          var date = new Date();
          setIsLoading(false);
        }

      } catch (e) {
        handleError(e, appDispatch);
      }
    };
    fetchNotification();



  }, [count]);

  useEffect(() => {
    if (notifyCount > 0) {
      setCounter(counter + 1)
    }
  }, [notifyCount]);


  const [checked, setChecked] = React.useState([1]);

  const handleToggl = (value) => () => {
    const currentIndex = checked.indexOf(value);
    const newChecked = [...checked];

    if (currentIndex === -1) {
      newChecked.push(value);
    } else {
      newChecked.splice(currentIndex, 1);
    }

    setChecked(newChecked);
  };
  const handleReadNotification = async (notification, index) => {

    if (notification.readed == false) {
      try {
        const response = await Axios.post(

          `${process.env.REACT_APP_API_URL}notification/marked`,
          { id: notification.id },
          {
            headers: {
              Authorization: `Bearer ${appState.token}`,
            },
          }
        );

        setCount(count + 1);
      } catch (e) {
        handleError(e, appDispatch);

      }
    } else {
      try {
        const response = await Axios.post(

          `${process.env.REACT_APP_API_URL}notification/unmarked`,
          { id: notification.id },
          {
            headers: {
              Authorization: `Bearer ${appState.token}`,
            },
          }
        );

        setCount(count + 1);
      } catch (e) {
        handleError(e, appDispatch);

      }
    }
  };
  const handleReadNotificationAndRedirect = async (notification, index) => {

    if (notification.readed == false) {
      try {
        const response = await Axios.post(

          `${process.env.REACT_APP_API_URL}notification/marked`,
          { id: notification.id },
          {
            headers: {
              Authorization: `Bearer ${appState.token}`,
            },
          }
        );

        setCount(count + 1);
        window.open(
          `https://${window.location.host}/invoice/in/${notification.data.data.invoice.id}`,
          "_blank"
        );
      } catch (e) {
      }
    } else {
      try {
        window.open(
          `https://${window.location.host}/invoice/in/${notification.data.data.invoice.id}`,
          "_blank"
        );
      } catch (e) {
      }
    }
  };

  // Function for Mark all notification
  const markAll = async () => {
    try {
      const response = await Axios.post(
        `${process.env.REACT_APP_API_URL}notification/markedall`,
        {},
        {
          headers: {
            Authorization: `Bearer ${appState.token}`,
          },
        }
      );
      setCount(count + 1);
    } catch (e) {
      handleError(e, appDispatch);

    }
  };

  return (
    <div id="Navbarv2Parent">
      <div className="Navbarv2 classForNotification">
        <Snackbar
          anchorOrigin={{ vertical: "top", horizontal: "right" }}
          open={alertMessage.open}
          className={alertMessage.alertSuccess ? "success-alert" : "danger-alert"}
        >
          {alertMessage.alertSuccess ? (
            <Alert severity="success">{alertMessage.message}</Alert>
          ) : (
            <Alert severity="error">{alertMessage.message}</Alert>
          )}
        </Snackbar>
        <nav className="navbar navbar-expand-lg navbar-light p-0 bg-light">
          <div className="container-fluid px-lg-5 px-3">
            <Link
              to={appState.loggedIn ? "/dashboard" : "/"}
              className="navbar-brand"
            >
              {!minDesktop ? <img
                src={vendorsConfig.APP_LOGO}
                alt={vendorsConfig.APP_NAME || "App Logo"}
                width="100"
              /> : ""}

              {minDesktop ? <img
                src={vendorsConfig.APP_LOGO}
                alt={vendorsConfig.APP_NAME || "App Logo"}
                width="100"
              /> : ""}



            </Link>
            {!minDesktop ? (
              <div className="d-flex align-items-center">
                {appState.langValue === "ar" ? (
                  <IconButton
                    id="headerBtn"
                    className=""
                    onClick={(e) => enLanguageHandle(e)}
                  >
                    <span className="lang-text">EN</span>
                  </IconButton>
                ) : (
                  <IconButton
                    id="headerBtn"
                    onClick={(e) => arLanguageHandle(e)}
                  >
                    <span className="lang-text familyGraphikArabic mb-2 pb-1 ">عربي</span>
                  </IconButton>
                )}
                {auth && (
                  <div>

                    <IconButton
                      size="medium"
                      aria-label="account of current user"
                      aria-controls="menu-appbar"
                      aria-haspopup="true"
                      onClick={handleMenu}
                      color="inherit"
                      className="nav_menu_toggler"
                    >
                      <Badge
                        badgeContent={notifyCount > 0 ? notifyCount : 0}
                        color="primary"
                      >
                        <img src={notificationIcon} alt="" />

                      </Badge>
                    </IconButton>


                    <Menu
                      id="menu-appbar"
                      anchorEl={anchorEl}
                      anchorOrigin={{
                        vertical: "top",
                        horizontal: "right",
                      }}
                      keepMounted
                      transformOrigin={{
                        vertical: "top",
                        horizontal: "right",
                      }}
                      open={Boolean(anchorEl)}
                      onClose={handleCloseNoti}
                      className="navbarNotificationv2"

                    >
                      <ListItem  >
                        <ListItemText className="notiTitle">
                          <h4 className="mb-0"><strong> Notification</strong></h4>
                        </ListItemText>

                        <ListItemAvatar className="notiTitle pb-1">


                          <IconButton onClick={handleCloseNoti}>
                            <CloseIcon />
                          </IconButton>


                        </ListItemAvatar>


                      </ListItem>

                      {notifications.length > 0 && <ListItem className="py-0 my-0">

                        <ListItemText className="notiTitle py-2 my-0">
                          <div>
                            <IconButton onClick={() => markAll()} className="readAllBtn rounded">
                              <h6 className="mb-0 textBlack"><strong>Mark as Read all</strong></h6>
                              <img className="mx-2" src={checkboxCircle} alt="" />
                            </IconButton>
                          </div>


                        </ListItemText>
                      </ListItem>}


                      {notifications.map((notification, index) => {

                        return (
                          <div
                            key={index}
                            className={`${notification.readed == true
                              ? "notificationReaded"
                              : "notificationNotReaded"
                              }`}
                          >
                            <ListItem key={index} button>
                              <ListItemAvatar>
                                <Avatar>

                                  <img src={Newspaper} />
                                </Avatar>
                              </ListItemAvatar>
                              <ListItemText
                                id={notification.id}
                                onClick={() =>
                                  handleReadNotificationAndRedirect(
                                    notification,
                                    index
                                  )
                                }
                              >
                                {notification.data.message} <br />
                              </ListItemText>
                              <h6 className="px-3">{notification.showTime}</h6>
                            </ListItem>
                          </div>
                        );
                      })}
                    </Menu>
                  </div>
                )}


                <IconButton
                  color="primary"
                  onClick={toggleDrawer(true)}
                  className="nav_menu_toggler"
                  aria-label="Menu"
                >
                  <MenuIcon />
                </IconButton>
              </div>
            ) : (
              ""
            )}

            {minDesktop ? (
              <div
                className="collapse navbar-collapse navbarnotification"
                id="navbarNav"
              >
                <ul
                  className={
                    appState.langValue === "ar"
                      ? "navbar-nav mr-auto"
                      : "navbar-nav ml-auto"
                  }
                >

                  {appState.loggedIn ? (
                    <>
                      <li style={{ display: "none" }} className="nav-item d-none">
                        <div className="nav-link">
                          {/* <Link to="/wallet"> */}
                          <Button className="walletBtn" onClick={walletShow}>
                            <div className="row m-0 align-items-center navBarwalletIcon">
                              <AccountBalanceWalletIcon />
                              <div className="WalletInfomration">
                                <p>
                                  <strong>
                                    <span className="amount">
                                      {appState.profile.wallet
                                        ? parseFloat(appState.profile.wallet.amount)
                                        : "0"}{" "}
                                    </span>

                                    <span className="kd">{t("KWD")}</span>
                                  </strong>
                                </p>
                              </div>
                            </div>
                          </Button>
                          {/* </Link> */}
                        </div>
                      </li>
                      <li
                        className={`${appState.langValue === "ar" ? "" : ""
                          } nav-item`}
                      >

                        {appState.langValue === "ar" ? (
                          <IconButton
                            id="headerBtn"
                            className=""
                            onClick={(e) => enLanguageHandle(e)}
                          >
                            <span className="lang-text">EN</span>
                          </IconButton>
                        ) : (
                          <IconButton
                            id="headerBtn"
                            className=""
                            onClick={(e) => arLanguageHandle(e)}
                          >
                            <span className="lang-text familyGraphikArabic mb-2 pb-1">عربي</span>
                          </IconButton>
                        )}
                      </li>
                      <li className="nav-item">
                        <div className="nav-link ">
                          {/* <Link to="/wallet"> */}

                          {auth && (
                            <div className="d-flex">

                              <IconButton
                                size="medium"
                                aria-label="account of current user"
                                aria-controls="menu-appbar"
                                aria-haspopup="true"
                                onClick={handleMenu}
                                color="inherit"
                                className="nav_menu_toggler"
                              >
                                <Badge
                                  badgeContent={notifyCount > 0 ? notifyCount : 0}
                                  color="primary"
                                >

                                  <img src={notificationIcon} alt="" />
                                </Badge>
                              </IconButton>

                              <Menu
                                id="menu-appbar"
                                anchorEl={anchorEl}
                                anchorOrigin={{
                                  vertical: "top",
                                  horizontal: "right",
                                }}
                                keepMounted
                                transformOrigin={{
                                  vertical: "top",
                                  horizontal: "right",
                                }}
                                open={Boolean(anchorEl)}
                                onClose={handleCloseNoti}
                                className="navbarNotificationv2"
                              >

                                <ListItem >
                                  <ListItemText className="notiTitle">
                                    <h4 className="mb-0"><strong>Notification</strong></h4>
                                  </ListItemText>


                                  <IconButton onClick={handleCloseNoti}>
                                    <CloseIcon />
                                  </IconButton>
                                </ListItem>
                                {notifications.length > 0 && <ListItem className="py-0 my-0">

                                  <ListItemText className="notiTitle py-3 my-0">
                                    <div>
                                      <Button onClick={() => markAll()} className="readAllBtn rounded">
                                        <h6 className="mb-0 textBlack"><strong>Mark as Read all</strong></h6>
                                        <img className="mx-2" src={checkboxCircle} alt="" />
                                      </Button>
                                    </div>


                                  </ListItemText>
                                </ListItem>}



                                {notifications.map((notification, index) => {
                                  return (
                                    <div
                                      key={index}
                                      className={`${notification.readed == true
                                        ? "notificationReaded"
                                        : "notificationNotReaded"
                                        }`}
                                    >
                                      <ListItem key={index} button>
                                        <ListItemAvatar>
                                          <Avatar>
                                            {/* <ReceiptIcon /> */}
                                            <img src={Newspaper} />
                                          </Avatar>
                                        </ListItemAvatar>
                                        <ListItemText
                                          id={notification.id}
                                          onClick={() =>
                                            handleReadNotificationAndRedirect(
                                              notification,
                                              index
                                            )
                                          }
                                        >
                                          {notification.data.message} <br />
                                        </ListItemText>
                                        <h6 className="px-3">{notification.showTime}</h6>
                                      </ListItem>

                                    </div>
                                  );
                                })}
                              </Menu>
                            </div>
                          )}

                          {/* </Link> */}
                        </div>
                      </li>



                      <li className="nav-item">
                        {/* Button */}
                        <ButtonGroup ref={anchorRef} aria-label="split button">
                          <Button
                            size="small"
                            className="border-0"
                            onClick={toggleDrawer(true)}
                          >
                            <div>

                              {appState.profile.image ? (
                                <img
                                  src={appState.profile.image}
                                  alt=""
                                  height="50px"
                                  width="50px"
                                  style={{ borderRadius: "50%" }}
                                />
                              ) : (
                                <img
                                  src={maleLogo}
                                  alt=""
                                  height="50px"
                                  width="50px"
                                />
                              )}
                            </div>
                            <p className=" m-0 px-2">{appState.profile.first_name}</p>
                            {/* <MenuIcon /> */}
                            <svg
                              xmlns="http://www.w3.org/2000/svg"
                              width="8.816"
                              height="4.776"
                              viewBox="0 0 8.816 4.776"
                            >
                              <g
                                id="down-arrow"
                                transform="translate(0 -117.336)"
                              >
                                <g
                                  id="Group_892"
                                  data-name="Group 892"
                                  transform="translate(0 117.336)"
                                >
                                  <path
                                    id="Path_3393"
                                    data-name="Path 3393"
                                    d="M8.709,117.444a.367.367,0,0,0-.519,0l-3.781,3.781L.627,117.444a.367.367,0,0,0-.519.519L4.149,122a.367.367,0,0,0,.519,0l4.041-4.041A.367.367,0,0,0,8.709,117.444Z"
                                    transform="translate(0 -117.336)"
                                    fill="#fff"
                                  />
                                </g>
                              </g>
                            </svg>
                          </Button>
                        </ButtonGroup>
                        {/* Popper For The Menu */}
                        <Popper
                          open={open}
                          anchorEl={anchorRef.current}
                          className="popper"
                          role={undefined}
                          transition
                          disablePortal
                        >
                          {({ TransitionProps, placement }) => (
                            <Grow
                              {...TransitionProps}
                              style={{
                                transformOrigin:
                                  placement === "bottom"
                                    ? "center top"
                                    : "center bottom",
                              }}
                            >
                              <Paper >
                                <ClickAwayListener onClickAway={handleClose}>
                                  <MenuList id="split-button-menu">
                                    <MenuItem className="navMenuItem">
                                      <Link
                                        to={`/dashboard/transactions`}
                                      >
                                        {" "}
                                        <i
                                          class="fas fa-history pr-2"
                                          aria-hidden="true"
                                        ></i>
                                        Transactions
                                      </Link>
                                    </MenuItem>
                                    <MenuItem
                                      id="simple-menu-0"
                                      className="navMenuItem"
                                    >
                                      <Link
                                        to={`/dashboard/promo`}
                                      >
                                        <i
                                          class="fas fa-percent pr-2"
                                          aria-hidden="true"
                                        ></i>
                                        {t("dashboard.promocodes")}
                                      </Link>
                                    </MenuItem>
                                    <MenuItem
                                      id="simple-menu-0"
                                      className="navMenuItem"
                                    >
                                      <Link
                                        to={`/dashboard/profile`}
                                      >
                                        <i className="far fa-user pr-2"></i>{" "}
                                        {t("dashboard.my-profile")}
                                      </Link>
                                    </MenuItem>
                                    <MenuItem
                                      id="simple-menu-0"
                                      className="navMenuItem"
                                    >
                                      <Link
                                        to={`/dashboard/orders`}
                                      >
                                        <i className="fas fa-list-ul pr-2"></i>
                                        {t("dashboard.orders")}
                                      </Link>

                                      <Link
                                        to={`/dashboard/rewards`}
                                      >
                                        {" "}
                                        <i
                                          class="fas fa-history pr-2"
                                          aria-hidden="true"
                                        ></i>
                                        Rewards
                                      </Link>
                                    </MenuItem>
                                    <MenuItem
                                      className="navMenuItem"
                                      onClick={handleLogout}
                                    >
                                      <strong>
                                        <i class="fas fa-sign-out-alt pr-2"></i>
                                        Logout
                                      </strong>
                                    </MenuItem>
                                  </MenuList>
                                </ClickAwayListener>
                              </Paper>
                            </Grow>
                          )}
                        </Popper>
                      </li>
                    </>
                  ) : (
                    ""
                  )}
                </ul>
              </div>
            ) : (
              ""
            )}
          </div>
        </nav>
        {/* {!minDesktop ? */}
        <div id={"mob-side-bar"} >
          <SwipeableDrawer
            anchor={appState.langValue === "ar" ? "right" : "left"}
            open={menuAnchor.open}
            onClose={toggleDrawer(false)}
            onOpen={toggleDrawer(true)}

          >

            <div className={` ${appState.langValue === "ar" ? "directionRtl" : ""} mob-menu-items-parentv2`}>
              <div
                className="mob-menu-itemsv2"
                style={appState.langValue === "ar" ? { direction: "rtl" } : {}}
              >
                <div
                  className={`mb-4 classForCloseIcon d-flex justify-content-between align-items-center  mt-2 ${appState.langValue === "ar"
                    ? "d-flex   "
                    : ""
                    }`}
                >
                  <h4 className="mb-0"> <strong>Menu</strong></h4>
                  <IconButton
                    onClick={toggleDrawer(false)}

                  >
                    <CloseIcon />
                  </IconButton>

                </div>

                <MenuList className="navMenuListv2">
                  <MenuItem className="side-menu-itemv2">
                    <Link
                      to={`/dashboard/profile`}
                      onClick={handleClick}
                      className="d-flex align-items-center"
                    >

                      <img className={
                        appState.langValue === "ar"
                          ? " text-primary pl-4"
                          : "text-primary pr-4"
                      } src={profile} />
                      <span>{t("dashboard.my-profile")}</span>
                    </Link>
                  </MenuItem>
                  {/* <MenuItem className="side-menu-itemv2">
                    <Link

                      to="/wallet"
                      className="d-flex align-items-center"
                    >

                      <img className={
                        appState.langValue === "ar"
                          ? " text-primary pl-4"
                          : "text-primary pr-4"
                      } src={Wallet} />
                      <span>{t("drawer.wallet")}</span>
                    </Link>
                  </MenuItem> */}
                  <MenuItem className="side-menu-itemv2">
                    <Link
                      to={`/dashboard/transactions`}
                      onClick={handleClick}
                      className="d-flex align-items-center"
                    >


                      <img className={
                        appState.langValue === "ar"
                          ? " text-primary pl-4"
                          : "text-primary pr-4"
                      } src={transaction} />
                      <span>{t("dashboard.transactions")}</span>
                    </Link>
                  </MenuItem>
                  <MenuItem className="side-menu-itemv2">
                    <Link
                      to={`/dashboard/orders`}
                      onClick={handleClick}
                      className="d-flex align-items-center"
                    >

                      <img className={
                        appState.langValue === "ar"
                          ? " text-primary pl-4"
                          : "text-primary pr-4"
                      } src={orders} />
                      <span>{t("dashboard.orders")}</span>
                    </Link>
                  </MenuItem>
                  <MenuItem className="side-menu-itemv2">
                    <Link
                      to={`/dashboard/promo`}
                      onClick={handleClick}
                      className="d-flex align-items-center"
                    >

                      <img className={
                        appState.langValue === "ar"
                          ? " text-primary pl-4"
                          : "text-primary pr-4"
                      } src={promocode} />
                      <span> {t("dashboard.promocodes")}</span>
                    </Link>
                  </MenuItem>



                  <MenuItem className="side-menu-itemv2">
                    <Link
                      to={`/dashboard/rewards`}
                      onClick={handleClick}
                      className="d-flex align-items-center"
                    >
                      <img className={
                        appState.langValue === "ar"
                          ? " text-primary pl-4"
                          : "text-primary pr-4"
                      } src={rewards} />
                      <span>{t("dashboard.rewards")}</span>
                    </Link>
                  </MenuItem>


                  <div className="logoutButton__iconv2">
                    <Button
                      className={`${appState.langValue === "ar" ? "d-flex btnRtl" : "d-flex"
                        } `}
                      onClick={handleLogout}
                    >
                      <img
                        src={logout}
                        width={35}
                        className={appState.langValue === "ar" ? "pl-3" : "pr-3"}
                        alt=""
                      />{" "}
                      <span>{t("drawer.log-out-btn")}</span>
                    </Button>
                  </div>
                </MenuList>
              </div>
            </div>
          </SwipeableDrawer>
          <div className="nav-mob"></div>
        </div>
        {/* } */}
      </div>
    </div>
  );
}

export default withTranslation()(Navbarv2);
